     $(function () {
        $('.reviews__list').slick({
          infinite: true,
          dots: true,
          arrows: false,
        });
      });